import {
  isMadBuyLineItemScheduleHourSelected,
  madBuyLineItemWeekDays,
  toggleMadBuyLineItemScheduleHour,
  type MadBuyLineItemDayTimeActivity,
  type MadBuyLineItemWeekDay,
} from '../../lineItemsModel';

export const scheduleHours = Array.from({ length: 24 }, (_, index) => index);

export const scheduleGuideLabels: Record<number, string> = {
  0: '12am',
  3: '3am',
  6: '6am',
  9: '9am',
  12: '12pm',
  15: '3pm',
  18: '6pm',
  21: '9pm',
};

export type ScheduleDragMode = 'add' | 'remove' | 'toggle';

export function setScheduleHour(
  activities: MadBuyLineItemDayTimeActivity[],
  day: MadBuyLineItemWeekDay,
  hour: number,
  mode: ScheduleDragMode,
) {
  const selected = isMadBuyLineItemScheduleHourSelected(activities, day, hour);
  if (mode === 'toggle' || (mode === 'add' && !selected) || (mode === 'remove' && selected)) {
    return toggleScheduleHour(activities, day, hour);
  }

  return activities;
}

export function setEveryDayHour(
  activities: MadBuyLineItemDayTimeActivity[],
  hour: number,
  mode: ScheduleDragMode,
) {
  let resolvedMode = mode;
  if (mode === 'toggle') {
    resolvedMode = isEveryDayHourSelected(activities, hour) ? 'remove' : 'add';
  }

  return madBuyLineItemWeekDays.reduce<MadBuyLineItemDayTimeActivity[]>((nextActivities, day) => {
    return setScheduleHour(nextActivities, day, hour, resolvedMode);
  }, activities);
}

export function isEveryDayHourSelected(activities: MadBuyLineItemDayTimeActivity[], hour: number) {
  return madBuyLineItemWeekDays.every((day) =>
    isMadBuyLineItemScheduleHourSelected(activities, day, hour),
  );
}

export function formatScheduleDayLabel(day: MadBuyLineItemWeekDay) {
  return day
    .toLowerCase()
    .split('_')
    .map((part) => `${part.slice(0, 1).toUpperCase()}${part.slice(1)}`)
    .join(' ');
}

export function formatScheduleHourLabel(hour: number) {
  const suffix = hour < 12 ? 'AM' : 'PM';
  const value = hour % 12 === 0 ? 12 : hour % 12;
  return `${String(value)} ${suffix}`;
}

function toggleScheduleHour(
  activities: MadBuyLineItemDayTimeActivity[],
  day: MadBuyLineItemWeekDay,
  hour: number,
) {
  const otherDays = activities.filter((activity) => activity.day !== day);
  const dayActivities = toggleMadBuyLineItemScheduleHour(
    activities.filter((activity) => activity.day === day),
    day,
    hour,
  );

  return [...otherDays, ...dayActivities];
}
